/* eslint-disable react-hooks/exhaustive-deps */
import { useState,useEffect } from "react";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import { useToastHandler } from "../../../../common/ToastHandler";
import useSwal from '../../../../common/ReusableComponent/useSwal'

const StockHistoryController = () => {
  const [stockData, setStockData] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const { Get, Delete ,getAPI , GetPaginatedData} = useApi();
  const { handleToast} = useToastHandler()
  const  {confirmDelete} = useSwal()

  // Debounce searchTerm
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 400);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  // Fetch stock data when debouncedSearchTerm changes
  useEffect(() => {
    const trimmed = debouncedSearchTerm.trim();
    if (trimmed === "" || trimmed.length >= 2) {
      fetchStockData({ page: currentPage, searchTerm: trimmed });
    }
    // else: do not call API for 1-char search
  }, [reloadData, currentPage, debouncedSearchTerm]);

  const fetchStockData = async ({ page = 1, searchTerm = "", sort = "" } = {}) => {
    try {
      setLoading(true);
      const response = await GetPaginatedData("productInventoryData", {
        page,
        search: searchTerm || undefined,
        queryParams: {
          ...(sort && { sort }),
        }
      });

      const results = response?.data || [];
      const count = response?.totalCount || 0;
      setStockData(results);
      setTotalCount(count);
      setCurrentPage(page);
      return { data: results, totalCount: count };
    } catch (error) {
      console.error("Failed to fetch stock data:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch stock data."
      });
      setStockData([]);
      setTotalCount(0);
      return { data: [], totalCount: 0 };
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const handleDataUpdate = () => {
    fetchStockData({ page: currentPage, searchTerm: debouncedSearchTerm });
  };

  const handleDeleteStock = async (id) => {
    try {
      const result = await confirmDelete();
      if (!result.isConfirmed) return;
      await Delete("productInventoryData", id);
      handleToast({
        type: "SUCCESS",
        message: "Stock deleted successfully!",
      });
      setReloadData(!reloadData);
    } catch (error) {
      console.error("Error deleting stock:", error);
      handleToast({
        type: "ERROR",
        message: "Error deleting stock",
      });
    }
  };

  const formatDate = (date) => {
    const formattedDate = new Date(date);
    return formattedDate.toLocaleString(); 
  };
  return {
    stockData,
    handleDeleteStock,
    formatDate,
    currentPage,
    totalCount,
    loading,
    handlePageChange ,
    handleDataUpdate,
    searchTerm,
    setSearchTerm,
    handleSearch
  };
};

export default StockHistoryController;
